import axios from 'axios'

// const API_URL = 'http://localhost:5000/api'

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });


const getToken = ()=>{
    const token = localStorage.getItem('bingo_access_token');
    const config = {
        headers:{
            Authorization: `Bearer ${token}`
        }
    };
    return config;
}

const credit_transfer = async (transferObj) =>{
    try {
        const data = await axiosInstance.post('/credit',transferObj,getToken());
        return data;
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}
const get_credit_for_user = async(phone)=>{
    try {
        if(phone && phone !== undefined){
            const data = await axiosInstance.get(`/credit/credit/${phone}`,getToken());
            return data;
        }
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}

const get_trx_history_and_credit = async(phone,fetchAll)=>{
    try {
        const data = await axiosInstance.get(`/credit/transactionHistoryCredit/${phone}/${fetchAll}`,getToken());
        return data;
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}

const get_trx_history_by_condition = async(reqObj)=>{
    try {
        const data = await axiosInstance.post('/credit/transactionHistoryCondition/',reqObj,getToken());
        return data;
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}




const get_trx_history = async(phone,fetchAll)=>{
    try {
        const data = await axiosInstance.get(`/credit/transactionHistory/${phone}/${fetchAll}`,getToken());
        return data;
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}

//transaction reverse

const get_trx_history_by_id = async(trx_id)=>{
    try {
        const data = await axiosInstance.get(`/credit/transactionHistoryById/${trx_id}`,getToken());
        return data;
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}


const reverse_trx = async(trx_id)=>{
    try {
        const data = await axiosInstance.get(`/credit/reverseTransaction/${trx_id}`,getToken());
        return data;
    } catch (error) {
        checkStatusAndRefreshPage(error);
        throw error.response.data;
    }
}

const getTransactionHistoriesByPhoneAndDate = async ({ phone, from, to }) => {
    try {
        const data = await axiosInstance.get(
            `/credit/transactionHistoryForUser?phone=${phone}&startDate=${from}&endDate=${to}`,
            getToken() // returns headers
        );
        return data.data;
    } catch (error) {
        console.log(error);
        checkStatusAndRefreshPage(error);
        throw error.response?.data || error.message;
    }
};


const checkStatusAndRefreshPage = async(error)=>{
    try {
        if(error.response.status === 401){
            window.location.reload();
            localStorage.removeItem('bingo_user_info');
            localStorage.removeItem('bingo_access_token');
        }
    } catch (error) {
        
    }
}


const creditService = {
    credit_transfer,
    get_credit_for_user,
    get_trx_history,
    get_trx_history_and_credit,
    get_trx_history_by_condition,
    reverse_trx,
    get_trx_history_by_id,
    getTransactionHistoriesByPhoneAndDate
};

export default creditService;